module.exports = __webpack_public_path__ + "static/pill-train-89e3794afe9d0d172fdbe2bf164e675e.svg";